import store from '../../config/store'

const Banner = {

  methods: {
    showBanner (type, message) {
      store.banner.type = type
      store.banner.message = message
      store.banner.active = true
    }
  }
}

export default Banner
